<template>
  <div class="carousel-container">
    <transition-group name="slide"
                      tag="div"
                      class="carousel">
      <div v-for="(slide, index) in slides"
           :key="slide.id || `slide-${index}`"
           v-show="currentSlide === index"
           class="carousel-slide"
           :style="{ display: 'flex', justifyContent: 'center', alignItems: 'center', background: slide.background || 'transparent' }"
           @click="slide.clickHandler">
        <img :src="slide.image"
             :style="slide.imageStyle"
             :alt="slide.alt">
        <span v-if="slide.description"
              class="logo-description">{{ slide.description }}</span>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: 'Carousel',
  props: {
    slides: {
      type: Array,
      required: true,
      validator: function (value) {
        return value.every((slide) => {
          return slide.id || slide.image || slide.description;
        });
      },
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
    interval: {
      type: Number,
      default: 5000,
    },
  },
  data() {
    return {
      currentSlide: 0,
      carouselInterval: null,
    };
  },
  mounted() {
    if (this.autoplay) {
      this.startCarousel();
    }
  },
  beforeDestroy() {
    this.stopCarousel();
  },
  methods: {
    startCarousel() {
      this.carouselInterval = setInterval(() => {
        this.currentSlide = (this.currentSlide + 1) % this.slides.length;
      }, this.interval);
    },
    stopCarousel() {
      if (this.carouselInterval) {
        clearInterval(this.carouselInterval);
      }
    },
  },
};
</script>

<style scoped>
.carousel-container {
  position: relative;
  width: 100%;
  height: 50px;
  overflow: hidden;
}

.carousel {
  position: relative;
  width: 100%;
  height: 100%;
}

.carousel-slide {
  position: absolute;
  width: 100%;
  height: 100%;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 1.5s ease;
}

.slide-enter {
  transform: translateX(100%);
}

.slide-leave-to {
  transform: translateX(-100%);
}
</style> 


// WEBPACK FOOTER //
// src/components/shareComponent/Carousel.vue